<template>
	<div class="w-full">
		<div class="mb-4 font-bold justify-center flex w-full">{{ $t('take_photo_work_step') }}</div>
		<div class="w-full gap-6">
			<div class="flex box-border p-4 border-2 border-gray-300 bg-gray-100 cursor-pointer" v-if="isImageContent">
				<div
					:style="{ backgroundImage: 'url(' + this.image.base64Content + ')' }"
					class="w-full flex flex-grow bg-cover bg-center h-64 relative text-right"
				></div>
			</div>
			<div class="flex flex-grow justify-center">
				<BaseCamera
					ref="Workingimages.BaseCamera"
					class="flex flex-shrink justify-center items-center"
					:disable-success-message="true"
					:enable-preview="false"
					:label="getBaseCameraLabel"
					:allow-upload-in-app-container="false"
					:app-mode="true"
					@snapshot="snapshotCam($event)"
				></BaseCamera>
			</div>
		</div>

		<div v-if="isImageContent" class="space-y-4 mt-4">
			<div class="flex flex-grow justify-end">
				<BaseCheckbox :label="$t('visible_for_customer')" v-model="image.show_customer" />
			</div>
			<BaseInput :label="$t('note')" v-model="image.note" class="h-32">
				<textarea class="w-full shadow-m h-32" v-model="image.note" maxlength="160"></textarea>
			</BaseInput>
		</div>

		<div class="flex justify-end">
			<BaseButton class="mt-6 w-full btn-blue" v-if="isUploadButtonActive" @click="uploadImages">
				<font-awesome-icon :icon="['fas', 'upload']" class="mr-4"></font-awesome-icon>{{ getUploadButtonLabel }}
			</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseCamera from '@/components/forms/inputs/BaseCamera';
import BaseButton from '@/components/forms/buttons/BaseButton';
import { AppsEmployeeApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/mixins/LoadingSpinner';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';
import BaseInput from '@/components/forms/inputs/BaseInput';
import Footer from '@/components/damagecases/Footer.vue';

export default {
	name: 'AppsEmployeeWorkingimages',
	components: { BaseInput, BaseCheckbox, BaseButton, BaseCamera },
	mixins: [LoadingSpinner],
	data() {
		return {
			imageList: [],
			image: {
				base64Content: null,
				note: '',
				show_customer: false,
			},
			baseCameraLabel: this.$t('add_photo'),
			isUploadButtonActive: false,
			showUploadSuccess: false,
			isUploading: false,
		};
	},
	computed: {
		getBaseCameraLabel() {
			return this.baseCameraLabel;
		},
		isImageContent() {
			return this.image.base64Content !== null;
		},
		getImageListCount() {
			return this.isUploading ? this.imageList.length : this.imageList.length + 1; // see uploadImages()
		},
		getUploadButtonLabel() {
			return this.getImageListCount + ' ' + (this.getImageListCount === 1 ? this.$t('photo') : this.$t('photos')) + ' ' + this.$t('upload');
		},
	},
	methods: {
		openUpload() {
			if (window.appcontainer.isiOSAppcontainer) {
				this.$refs['Workingimages.BaseCamera'].openCamera();
			} else {
				this.$refs['Workingimages.BaseCamera'].openUpload();
			}
		},
		snapshotCam(event) {
			this.showUploadSuccess = false;

			// Beim neuen Foto wird das, alte in die Liste übernommen. Beim ersten, mal wird nichts der Liste hinzugefügt
			if (this.image.base64Content) {
				this.imageList.push({
					type: 'image',
					...this.image,
				});

				this.image.note = '';
				this.image.show_customer = true;
			}

			if (!event.startsWith('data:image')) {
				this.image.base64Content = 'data:image/jpeg;base64,' + event;
			} else {
				this.image.base64Content = event;
			}

			this.baseCameraLabel = this.$t('add_another_photo');
			this.isUploadButtonActive = true;
		},
		uploadImages() {
			this.isUploading = true;
			// Damit das neueste Bild auch hochgeladen wird
			this.imageList.push({
				type: 'image',
				...this.image,
			});

			this.setLoadingStatus(true);
			AppsEmployeeApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.appsEmployeeWorkingimagesPost(this.imageList)
				.then(result => {
					this.imageList = [];
					this.image.base64Content = null;
					this.image.note = '';
					this.image.show_customer = true;
					this.isUploadButtonActive = false;
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('upload_successful').toString(),
						icon: 'success'
					}).then(_ => {
						this.$router.push({ name: 'AppsEmployeeMain' });
					});
					this.setLoadingStatus(false);
				})
				.catch(error => {
					this.setLoadingStatus(false);
				})
				.finally(() => (this.isUploading = false));
		},
	},
};
</script>

<style scoped></style>
